import { Variants } from "framer-motion"

export const opacityVariants: Variants = {
  hidden: { opacity: 0 },
  shown: { opacity: 1 },
}

const fadeUpTransition = { duration: 0.255, ease: "easeInOut" }
export const fadeUp: Variants = {
  hidden: { opacity: 0, translateY: 0, transition: fadeUpTransition },
  shown: { opacity: 1, translateY: 0, transition: fadeUpTransition },
}
